<template>
  <b-row v-if="$route.name === 'UserDataCreate'">
    <b-col cols="12" class="mb-1">
      <router-link  :to="{ name: 'UserDataList' }" class="btn btn-sm btn-default float-right">
        <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
        <i v-else class="far fa-arrow-alt-left"></i>
      </router-link>
    </b-col>
    <b-col cols="12">
      <b-card>
        <Loader v-if="isLoading"></Loader>
        <UserDataForm v-else
                      :handle-submit="onSendForm"
                      :handle-update-field="updateField"
                      :values="item"
                      :errors="violations" />
      </b-card>
    </b-col>
  </b-row>
  <div v-else>
    <Loader v-if="isLoading"></Loader>
    <UserDataForm v-else
                  :handle-submit="onSendForm"
                  :handle-update-field="updateField"
                  :values="item"
                  :errors="violations" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import UserDataForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('userdata/create')

export default {
  components: {
    UserDataForm,
    Loader
  },

  props: ['clientType', 'isContractor'],

  data () {
    return {
      routeName: '',
      item: {
        mobilePhone: '+48 ',
        idClientType: this.clientType,
        isContractor: this.isContractor,
        userDataTags: []
      }
    }
  },

  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ]),

    mobileView () {
      return this.$store.state.mobileView
    }
  },

  watch: {
    created (val) {
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = JSON.parse(JSON.stringify(this.item))
      item.userDataTags = item.userDataTags.map(entry => {
        return { '@id': entry['@id'], idTag: entry.value, idUserData: item['@id'], text: entry.text, value: entry.value }
      })
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
